import { HTTPServiceClient } from '@/packages/http/service';
import * as ep from './endpoints';

export const AppService = {
  changePassWord(data: object): Promise<any> {
    return HTTPServiceClient.post(ep.CHANGE_PASSWORD, data).then(({ data }) => data);
  }
};
